export default __webpack_public_path__ + "static/greycliff-cf-medium-4de63696feebc02bc4e07aa482d27eac.woff2";